import { currentUpgradeInfo } from '@/service/account'

const MONTHLY = 'monthly'
const ANNUITY = 'annuity'

const initialState = () => ({
  data: {
    partialPrice: '-',
    originalPrice: '-',
    period: MONTHLY,
    nextCharge: '',
  },
})

const state = initialState()

const getters = {
  originalPrice: state => state.data.originalPrice,
  partialPrice: state => state.data.partialPrice,
  nextCharge: state => state.data.nextCharge,
  period: state => state.data.period,
  isAnnuity: state => state.data.period === ANNUITY,
}

const mutations = {
  UPDATE_DATA: (state, data) =>
    (state.data = Object.assign({}, state.data, data)),
}

const actions = {
  async loadSimulationData({ commit }) {
    const data = await currentUpgradeInfo()

    commit('UPDATE_DATA', {
      partialPrice: data.partialPricePerUser,
      originalPrice: data.pricePerUser,
      period: data.period,
      nextCharge: data.nextCharge,
    })
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
